import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fNumber(number) {
  return numeral(number).format();
}

export function fCurrency(number) {
  if (number === null || number === undefined || isNaN(number)) {
    return '';
  }

  return numeral(number).format('0,0.00');
}

export function fPercent(number) {
  if(number === 0)return '0%';

  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

export function customRound(number, decimalPlaces) {
  const factor = 10 ** decimalPlaces;
  const tempNumber = number * factor;
  const roundedTemp = Math.floor(tempNumber);
  if (tempNumber - roundedTemp === 0.5) {
      return roundedTemp / factor;
  }
  return Math.round(tempNumber) / factor;
}

export function formatReference(reference) {
  if(reference!== undefined&& reference !== null){
    const position = reference.length - 5; 
    return reference.slice(0, position) + reference.slice(position + 2);
  }

  return null;
}
